<template>
<div class="top-nav-container">
  <div class="main-1 clearfix">
    <div class="logo left">
      <img src="~assets/logo.jpg" alt="logo" />
      <span></span>
    </div>
    <div class="page-nav left">
      <nuxt-link v-for="item of navList" :key="item.path" :to="item.path" :exact="item.path === '/'">{{ item.title }}</nuxt-link>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'TopNav',
  data () {
    return {
      hangzhouNavList: [
        { title: '首页', path: '/' },
        { title: '商务合作', path: '/vertically' },
        { title: '信息资讯', path: '/news' },
        { title: '招贤纳士', path: '/join' },
        { title: '我的', path: '/user' },
        { title: '关于', path: '/about' },
      ],
      defaultNavList: [
        { title: '首页', path: '/' },
        { title: '互动', path: '/room' },
        { title: '问答', path: '/question' },
        { title: '文章', path: '/article' },
        { title: '我的', path: '/user' },
        { title: '关于', path: '/about' },
      ],
      navList: [],
      keyword: '',
      unread: '',
      isIE: false
    }
  },
  mounted () {
    this.isIE = /Trident/.test(navigator.userAgent)
    this.initNavMenu()
  },
  methods: {
    normalizeCityName(city) {
      if (!city || typeof city !== 'string') {
        return ''
      }

      const value = city.trim()
      const cityMap = {
        'hangzhou': '杭州',
        'hangchow': '杭州',
        '杭州市': '杭州',
        'Hangzhou': '杭州',
        'Hangchow': '杭州',
        'shanghai': '上海',
        '上海市': '上海',
        'Shanghai': '上海',
        'beijing': '北京',
        '北京市': '北京',
        'Beijing': '北京'
      }

      return cityMap[value] || value
    },

    isHangzhouLocation(location) {
      if (!location) {
        return false
      }

      const values = typeof location === 'string'
        ? [location]
        : Array.isArray(location)
        ? location
        : Object.keys(location).map(key => location[key])

      return values.some((value) => {
        if (!value || typeof value !== 'string') {
          return false
        }
        const normalized = this.normalizeCityName(value)
        return normalized === '杭州' || normalized.includes('杭州') || /^hangzhou$/i.test(value.trim())
      })
    },

    cacheCity(city) {
      if (!city) {
        return
      }
      localStorage.setItem('user_city', city)
      localStorage.setItem('user_city_time', String(Date.now()))
    },

    async readResponseData(response) {
      const contentType = response.headers.get('content-type') || ''

      if (contentType.includes('application/json')) {
        return response.json()
      }

      const text = await response.text()
      const jsonText = text.trim().replace(/^[^(]*\(/, '').replace(/\)$/, '')

      try {
        return JSON.parse(jsonText)
      } catch (e) {
        return text
      }
    },

    getJsonp(url, callbackParam = 'callback') {
      return new Promise((resolve, reject) => {
        const callbackName = `jsonp_${Date.now()}_${Math.random().toString(16).slice(2)}`
        const script = document.createElement('script')
        const separator = url.includes('?') ? '&' : '?'
        const timer = window.setTimeout(() => {
          cleanup()
          reject(new Error('jsonp timeout'))
        }, 8000)

        const cleanup = () => {
          window.clearTimeout(timer)
          delete window[callbackName]
          if (script.parentNode) {
            script.parentNode.removeChild(script)
          }
        }

        window[callbackName] = (data) => {
          cleanup()
          resolve(data)
        }

        script.onerror = () => {
          cleanup()
          reject(new Error('jsonp error'))
        }

        script.src = `${url}${separator}${callbackParam}=${callbackName}`
        document.body.appendChild(script)
      })
    },

    async getCurrentCity() {
      const cachedCity = localStorage.getItem('user_city')
      const cacheTime = Number(localStorage.getItem('user_city_time'))
      
      if (cachedCity && cacheTime && (Date.now() - cacheTime < 10 * 60 * 1000)) {
        return cachedCity
      }
      
      const apis = [
        {
          name: 'ipwho',
          url: 'https://ipwho.is/',
          parse: (data) => ({
            city: data.city,
            region: data.region,
            country: data.country
          })
        },
        {
          name: 'ipapi',
          url: 'https://ipapi.co/json/',
          parse: (data) => ({
            city: data.city,
            region: data.region,
            country: data.country_name
          })
        },
        {
          name: 'ip-sb',
          url: 'https://api.ip.sb/geoip',
          parse: (data) => ({
            city: data.city,
            region: data.region,
            country: data.country
          })
        },
        {
          name: 'ipip',
          url: 'https://myip.ipip.net',
          parse: (data) => {
            const match = data.match(/来自于:\s*(.+)/)
            if (match) {
              const parts = match[1].trim().split(/\s+/)
              if (parts.length >= 3) {
                return parts[2]
              }
              for (let i = parts.length - 1; i >= 0; i--) {
                const word = parts[i]
                if (!['移动', '电信', '联通', '铁通', '网通'].includes(word)) {
                  return word
                }
              }
              return parts[parts.length - 1] || null
            }
            return null
          }
        },
        {
          name: 'pconline',
          url: 'https://whois.pconline.com.cn/ipJson.jsp?json=true',
          type: 'jsonp',
          parse: (data) => {
            return {
              city: data.city,
              region: data.pro,
              country: data.addr
            }
          }
        }
      ]
      
      for (const api of apis) {
        try {
          let data = null

          if (api.type === 'jsonp') {
            data = await this.getJsonp(api.url)
          } else {
            const response = await fetch(api.url, {
              mode: 'cors',
              cache: 'no-cache'
            })
            
            if (!response.ok) {
              continue
            }
            
            data = await this.readResponseData(response)
          }

          const location = api.parse(data)

          if (this.isHangzhouLocation(location)) {
            this.cacheCity('杭州')
            return '杭州'
          }

          const city = typeof location === 'string' ? location : location && location.city
          const result = this.normalizeCityName(city)

          if (result) {
            this.cacheCity(result)
            return result
          }
        } catch (error) {
          continue
        }
      }
      
      return null
    },
    
    async initNavMenu() {
      this.navList = this.defaultNavList
      
      try {
        const city = await this.getCurrentCity()
        console.log('返回数据:', city)
        const isHangzhou = this.isHangzhouLocation([city])
        
        if (isHangzhou) {
          this.navList = this.hangzhouNavList
        }
      } catch (error) {
        this.navList = this.defaultNavList
      }
    },
    
    search () {
      if (this.keyword !== '') {
        this.$router.push({ path: '/search', query: { keyword: this.keyword } })
        this.keyword = ''
      }
    }
  }
}
</script>

<style lang="less" scoped>
.top-nav-container {
  background: #e43a3d;
}
.logo {
  float: left;
}
.logo img {
  width: 120px;
  height: 43px;
  display: inline-block;
  margin: 24px 100px 0 0;
}
.page-nav {
  float: left;
  overflow: hidden;
}
.page-nav a {
  float: left;
  line-height: 90px;
  width: 80px;
  font-size: 16px;
  color: #fff;
  text-align: center;
  text-decoration: none;
}
.page-nav a:hover:not(.nuxt-link-active) {
  background: rgba(198, 20, 32, .4);
}
.page-nav a.nuxt-link-active {
  background: #C61420;
  font-weight: bold;
}
.clearfix:after {
  content: '';
  display: table;
  clear: both;
}
.left {
  float: left;
}
</style>
